import axios from 'axios';
import { apiPaths } from 'constants/path';
import { clAdminTokenHeader } from 'functions/apiFunctions';
import { HospitalListApi } from 'models/CL/CLApiTypes';

class HospitalApi {
    async getHospitalList(token: string): Promise<HospitalListApi> {
        try {
            const response = await axios.get(apiPaths.CLGetHospitalList, { headers: clAdminTokenHeader(token) });
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export const CLHospitalApi = new HospitalApi();
